// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const getFilteredValueField = filterSelect => {
  switch (filterSelect) {
    case 'antennaCode' :
      return ['antennas', 'primary', 'antennaCode']

    case 'antennaModel' :
      return ['antennas', 'primary', 'modelNumber']

    case 'callSign' :
      return ['callSign']

    case 'maxPower' :
      return ['radio', 'maxPower']

    case 'radioBandwidth' :
      return ['bandwidth']

    case 'radioCode' :
      return ['radio', 'radioCode']

    case 'segmentStatus' :
      return ['segmentStatus']

    case 'siteName' :
      return ['siteName']

    default:
      throw new Error(`getFilteredValueField error: unmapped selectValue of ${filterSelect}`)
  }
}

export default getFilteredValueField
